import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import { displayErrorToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { documentListRequest } from '../../../redux/document/document.action'
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import moment from "moment";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import { Modal, Button } from 'react-bootstrap';
import { config } from "../../../config";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";

const DocumentList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { documentListSuccess, documentListError } = useSelector(state => state.document)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [showDocumentModal, setShowDocumentModal] = useState(false)
    const [viewFileUrl, setViewFileUrl] = useState()
    const [downloadFileUrl, setDownloadFileUrl] = useState()

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.DOCUMENT_LIST, true)
            fetchBusinessList()
        }
        if (isLoggedInUserEmployee(user)) {
            fetchDocumentList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.DOCUMENT_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.DOCUMENT_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(documentListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(documentListError)) {
            setLoading(false)
        }
    }, [documentListSuccess, documentListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchDocumentList()
        }
    }, [selectedLocation])

    const fetchDocumentList = () => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user)) {
            if (!isEmpty(selectedBusiness)) {
                data.businessId = selectedBusiness.businessId
                data.locationId = selectedLocation.locationId
            }
        }
        if (isLoggedInUserEmployee(user)) {
            if (!isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
                data.businessId = employeeSelectedBusiness
                data.locationId = employeeSelectedLocation
            }
            data.assignorId = user.data.userDetails.employeeId
            data.assignorUserType = user.data.userDetails.userType
            data.assigneeId = user.data.userDetails.employeeId
            data.assigneeUserType = user.data.userDetails.userType
        }

        dispatch(documentListRequest(data))
    }

    const handleViewDetail = (item) => {
        setViewFileUrl(`${config.imageUrl}document/view?filename=${item.document}`)
        setDownloadFileUrl(`${config.imageUrl}document/download?filename=${item.document}`)
        setShowDocumentModal(true)
    }

    const handleAddDocumentClick = () => {
        navigate(ROUTES.documents.add)
    }

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.DOCUMENTS.ADD_DOCUMENT) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.DOCUMENTS, PERMISSION_SUB_TYPE.DOCUMENTS.ADD_DOCUMENT, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Documents' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                {!isNull(documentListSuccess) && !isEmpty(documentListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Assignor</th>
                                <th scope="col" className="text-center">Assignor Type</th>
                                <th scope="col" className="text-center">Assignee</th>
                                <th scope="col" className="text-center">Assignee Type</th>
                                <th scope="col" className="text-center">Date</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {documentListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.name}</td>
                                    <td className="text-center">{!isEmpty(element.assignorDetails) ? `${element.assignorDetails.firstName} ${element.assignorDetails.lastName}` : '-'}</td>
                                    <td className="text-center">{!isEmpty(element.assignorDetails) ? removeSpecialCharAndChangeToPascal(element.assignorDetails.userType) : '-'}</td>
                                    <td className="text-center">{!isEmpty(element.assigneeDetails) ? `${element.assigneeDetails.firstName} ${element.assigneeDetails.lastName}` : '-'}</td>
                                    <td className="text-center">{!isEmpty(element.assigneeDetails) ? removeSpecialCharAndChangeToPascal(element.assigneeDetails.userType) : '-'}</td>
                                    <td className="text-center">{moment.utc(element.createdOn).local().format('DD MMM YYYY')}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(documentListError) && <div className="content-error">{documentListError.message}</div>}
                {isPermissionAllowed(PERMISSION_SUB_TYPE.DOCUMENTS.ADD_DOCUMENT) && <div className="vl-fab-container" onClick={() => handleAddDocumentClick()}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowDocumentModal(false) }}
                show={showDocumentModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Document Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    {!isEmpty(viewFileUrl) && <iframe
                        src={viewFileUrl}
                        style={{ width: "100%", height: "60vh", border: "none" }}
                        title="Document Viewer"
                    />}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { setShowDocumentModal(false) }}>
                        Close
                    </Button>
                    {!isEmpty(downloadFileUrl) && <Button variant="primary" href={downloadFileUrl} download>
                        Download File
                    </Button>}
                </Modal.Footer>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default DocumentList